export enum TextStyle {
    UPPERCASE = 'Uppercase',
    LOWERCASE = 'Lowercase',
    TITLECASE = 'Titlecase',
}
